<div class="doing-form" [ngClass]="(position$ | async)" #doingForm>
    <div class="doing-tags">
        <div class="tag followup" [matMenuTriggerFor]="calendar">
            <span class="iconify mr-1" data-icon="tabler:calendar"></span>
            <ng-container *ngIf="doing.followUp">{{ doing.followUp | date: 'dd.MM.yyyy' }}</ng-container>
            <span class="no-followup" *ngIf="!doing.followUp">Kein Follow-Up</span>
            <mat-menu #calendar>
                <div (click)="$event.stopPropagation()" class="w-64">
                    <mat-calendar (selectedChange)="doing.followUp = $event; calendar.closed.emit()" [selected]="doing.followUp"></mat-calendar>
                </div>
            </mat-menu>
        </div>
        <div class="tag" *ngIf="doing.markedUser != null">
            {{ doing.markedUser.username }}
            <div class="remove-tag" title="Tag entfernen" (click)="doing.markedUser = null" *ngIf="userSearchEnabled">
                <span class="iconify" data-icon="eva:close-outline"></span>
            </div>
        </div>
        <div class="tag" *ngIf="doing.customer != null">
            {{ doing.customer.companyDisplayName }}
            <div class="remove-tag" title="Tag entfernen" (click)="doing.customer = null" *ngIf="customerSearchEnabled">
                <span class="iconify" data-icon="eva:close-outline"></span>
            </div>
        </div>
        <div class="tag" *ngIf="doing.cooperation != null">
            {{ doing.cooperation.name }}
            <div class="remove-tag" title="Tag entfernen" (click)="doing.cooperation = null" *ngIf="cooperationSearchEnabled">
                <span class="iconify" data-icon="eva:close-outline"></span>
            </div>
        </div>
    </div>
    <div class="input-wrapper">
        <div #searchMenuTrigger [matMenuTriggerFor]="searchMenu" class="visibility-hidden"></div>
        <input #doingInput (keydown)="keyDown($event)" [placeholder]="placeholderText" type="text" [(ngModel)]="doing.text" />
        <div class="doing-state" [matMenuTriggerFor]="doingStateMenu" [ngClass]="doing.state">
            <ng-container [ngSwitch]="doing.state">
                <ng-container *ngSwitchCase="'new'">Offen</ng-container>
                <ng-container *ngSwitchCase="'success'">Erfolg</ng-container>
                <ng-container *ngSwitchCase="'fail'">Abgelehnt</ng-container>
            </ng-container>
        </div>
        <mat-menu #doingStateMenu>
            <div mat-menu-item (click)="doing.state = 'new'">Offen</div>
            <div mat-menu-item (click)="doing.state = 'success'">Erfolg</div>
            <div mat-menu-item (click)="doing.state = 'fail'">Abgelehnt</div>
        </mat-menu>

        <mat-menu #searchMenu class="search-menu" (click)="$event.stopPropagation()" (closed)="menuClosed()">
            <div class="search-query" [style.width]="doingForm.getBoundingClientRect().width + 'px'">
                <input (blur)="searchQueryInput.focus()" (keydown.escape)="escapePressed()" (keydown.backspace)="backspacePressed()" (keydown.enter)="saveSearch()" #searchQueryInput ngModel (ngModelChange)="setQuery($event)" type="text" placeholder="Nach Kunden, Artists, Kooperationen suchen..." />
            </div>
            <div class="search-results">
                    <button mat-menu-item *ngFor="let result of (results$ | async); index as i" [class.active]="selectedIndex == i" (click)="applyContext(result)">
                        <div class="label">{{ result.label }}</div>
                        <div class="text-xs text-gray-600" *ngIf="result.description">{{ result.description }}</div>
                        <div class="text-2xs">
                            <span *ngIf="result.type == 'customer'">Kunde</span>
                            <span *ngIf="result.type == 'cooperation'">Kooperation</span>
                            <span *ngIf="result.type == 'user'">
                    <span *ngIf="result.originalObject.roles.indexOf('ROLE_CRM_MANAGER') >= 0">Manager</span>
                    <span *ngIf="result.originalObject.roles.indexOf('ROLE_CRM_MANAGER') < 0 && result.originalObject.roles.indexOf('ROLE_CRM_INFLUENCER') >= 0">Artist</span>
                  </span>
                        </div>
                    </button>
                    <button mat-menu-item (click)="addCustomer()" *ngIf="customerSearchEnabled">
                        <div class="add-customer" *ngIf="!matchInType('customer')">
                            + Unternehmen erstellen
                        </div>
                    </button>
            </div>
        </mat-menu>

    </div>
</div>
